"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADDBLOCKMENU_ITEMS = exports.AddBlockMenu = void 0;
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var AddBlockMenuItem_1 = require("./AddBlockMenuItem");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var ProjectTypes_1 = require("Project/ProjectTypes");
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var icons_2 = require("@qwilr/kaleidoscope/icons");
var DEFAULT_ADDBLOCKMENU_ITEMS = [
    BlockTypes_1.BlockType.Text,
    BlockTypes_1.BlockType.Splash,
    BlockTypes_1.BlockType.Quote,
    BlockTypes_1.BlockType.Video,
    BlockTypes_1.BlockType.Source,
    BlockTypes_1.BlockType.Accept,
];
exports.DEFAULT_ADDBLOCKMENU_ITEMS = DEFAULT_ADDBLOCKMENU_ITEMS;
var c = (0, BemBuilder_1.default)("add-block-menu");
var PRESET_SCROLL_TOP_OFFSET = 256;
var AddBlockMenu = (function (_super) {
    __extends(AddBlockMenu, _super);
    function AddBlockMenu() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.currentPanel = "blocks";
        _this._popoverRef = react_1.default.createRef();
        _this.onSelectBlockType = function (blockType) {
            var config = _this.getItemConfiguration(blockType);
            if (config.isDisabled) {
                return;
            }
            if (config.presets) {
                _this.currentPanel = "presets";
                _this.selectedConfig = config;
                if (_this.popoverRef.current && _this.props.shouldScrollToPopover) {
                    window.requestAnimationFrame(function () {
                        var scrollContainer = document.querySelector(".content-container__scroll-container");
                        scrollContainer.scrollTo({
                            left: 0,
                            top: scrollContainer.scrollTop + _this.popoverRef.current.getBoundingClientRect().y - PRESET_SCROLL_TOP_OFFSET,
                            behavior: "smooth",
                        });
                    });
                }
                return;
            }
            _this.props.onBlockClick({ blockType: blockType });
        };
        _this.onSelectPreset = function (blockType, preset) {
            _this.props.onBlockClick({ blockType: blockType, preset: preset });
        };
        _this.onClosePresets = function () {
            _this.currentPanel = "blocks";
        };
        _this.setPanelHeight = function (node) {
            _this.panelHeight = node.offsetHeight;
        };
        _this.getItemConfiguration = function (blockType) {
            var _a;
            var disabledCreateOptions = _this.props.disabledCreateOptions;
            var isAcceptDisabled = disabledCreateOptions.includes(BlockTypes_1.BlockType.Accept) || _this.project.hasAcceptEnabled;
            var usingEsign = !_this.usingFeature(FeatureFlag_1.default.OptOutNewEditor);
            var configs = (_a = {},
                _a[BlockTypes_1.BlockType.Accept] = {
                    blockType: BlockTypes_1.BlockType.Accept,
                    text: "accept",
                    icon: usingEsign ? react_1.default.createElement(icons_2.BlockAcceptEsign, { size: icons_1.IconSize.Large }) : react_1.default.createElement(icons_1.BlockAccept, { size: icons_1.IconSize.Large }),
                    disabledTooltipContent: _this.disabledAcceptTooltip(),
                    isDisabled: isAcceptDisabled,
                    presetTitle: "Choose an accept preset",
                    presets: [
                        {
                            preset: BlockTypes_1.BlockPreset.AcceptClickTo,
                            title: "click to accept",
                            description: "Clients enter their details and accept with a single click",
                            image: "/Assets/Images/blockPresets/preset-click-to-accept.png",
                        },
                        {
                            preset: BlockTypes_1.BlockPreset.AcceptEsign,
                            title: "e-signature",
                            description: "Require clients to securely submit an electronic signature to accept",
                            image: "/Assets/Images/blockPresets/preset-esignature.png",
                        },
                        {
                            preset: BlockTypes_1.BlockPreset.AcceptMultiEsign,
                            title: "multi-accept & e-sign",
                            description: "Get acceptance and e-signatures from multiple clients",
                            image: "/Assets/Images/blockPresets/preset-multi-accept.png",
                        },
                    ],
                },
                _a[BlockTypes_1.BlockType.OldQuote] = {
                    blockType: BlockTypes_1.BlockType.OldQuote,
                    text: "quote",
                    icon: react_1.default.createElement(icons_1.BlockQuote, { size: icons_1.IconSize.Large }),
                    disabledTooltipContent: (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", null, "Interactive pricing is only available on our paid plans."),
                        react_1.default.createElement("a", { className: "tooltip-link", href: "/#/settings/subscription" }, "View plans & upgrade"))),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.OldQuote),
                },
                _a[BlockTypes_1.BlockType.Quote] = {
                    blockType: BlockTypes_1.BlockType.Quote,
                    text: "quote",
                    icon: react_1.default.createElement(icons_1.BlockQuote, { size: icons_1.IconSize.Large }),
                    disabledTooltipContent: (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", null, "Interactive pricing is only available on our paid plans."),
                        react_1.default.createElement("a", { className: "tooltip-link", href: "/#/settings/subscription" }, "View plans & upgrade"))),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.Quote),
                    presetTitle: "Choose a quote preset",
                    presets: [
                        {
                            preset: BlockTypes_1.BlockPreset.QuoteTableOnly,
                            title: "standard quote",
                            image: "/Assets/Images/blockPresets/table-only.png",
                        },
                        {
                            preset: BlockTypes_1.BlockPreset.QuotePlansOnly,
                            title: "plans only",
                            image: "/Assets/Images/blockPresets/plans-only.png",
                        },
                        {
                            preset: BlockTypes_1.BlockPreset.QuoteCombinedPlansAndTable,
                            title: "combined plans and quote",
                            image: "/Assets/Images/blockPresets/combined-plans-and-table.png",
                        },
                    ],
                },
                _a[BlockTypes_1.BlockType.Source] = {
                    blockType: BlockTypes_1.BlockType.Source,
                    text: "embed",
                    icon: react_1.default.createElement(icons_1.BlockEmbed, { size: icons_1.IconSize.Large }),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.Source),
                },
                _a[BlockTypes_1.BlockType.Splash] = {
                    blockType: BlockTypes_1.BlockType.Splash,
                    text: "splash",
                    icon: react_1.default.createElement(icons_1.BlockSplash, { size: icons_1.IconSize.Large }),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.Splash),
                },
                _a[BlockTypes_1.BlockType.Text] = {
                    blockType: BlockTypes_1.BlockType.Text,
                    text: "text",
                    icon: react_1.default.createElement(icons_1.BlockText, { size: icons_1.IconSize.Large }),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.Text),
                },
                _a[BlockTypes_1.BlockType.Video] = {
                    blockType: BlockTypes_1.BlockType.Video,
                    text: "video",
                    icon: react_1.default.createElement(icons_1.BlockVideo, { size: icons_1.IconSize.Large }),
                    isDisabled: disabledCreateOptions.includes(BlockTypes_1.BlockType.Video),
                },
                _a);
            var selectedConfig = configs[blockType];
            return (0, mobx_1.computed)(function () { return selectedConfig; }).get();
        };
        return _this;
    }
    Object.defineProperty(AddBlockMenu.prototype, "popoverRef", {
        get: function () {
            var _a;
            return (_a = this.props.innerRef) !== null && _a !== void 0 ? _a : this._popoverRef;
        },
        enumerable: false,
        configurable: true
    });
    AddBlockMenu.prototype.disabledAcceptTooltip = function () {
        if (this.project.hasAcceptEnabled) {
            return react_1.default.createElement("div", null, "Only one accept block allowed per page");
        }
        else {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, "Accept, e-sign & payments are only available on our paid plans."),
                react_1.default.createElement("a", { className: "tooltip-link", href: "/#/settings/subscription" }, "View plans & upgrade")));
        }
    };
    AddBlockMenu.prototype.componentDidMount = function () {
        this.panelHeight = this.popoverRef.current.offsetHeight;
    };
    AddBlockMenu.prototype.render = function () {
        var _a;
        var _this = this;
        var _b;
        var _c = this.props, hideAddFromLibrary = _c.hideAddFromLibrary, onAddFromLibraryClick = _c.onAddFromLibraryClick, blockTypes = _c.blockTypes, position = _c.position, zIndex = _c.zIndex;
        return (react_1.default.createElement(kaleidoscope_2.Panel, { className: (0, classnames_1.default)(c(), (_a = {},
                _a[c("", "showing-blocks")] = this.currentPanel === "blocks",
                _a[c("", "showing-presets")] = this.currentPanel === "presets",
                _a)), style: __assign(__assign({ height: this.panelHeight }, ((_b = position === null || position === void 0 ? void 0 : position.overlay) !== null && _b !== void 0 ? _b : {})), { zIndex: zIndex }), ref: this.popoverRef },
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null },
                this.currentPanel === "blocks" && (react_1.default.createElement(react_transition_group_1.Transition, { timeout: kaleidoscope_3.AnimationDuration.Long, onEnter: this.setPanelHeight }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("popover-panel"), c("popover-panel", "blocks"), c("popover-panel", status)) },
                    react_1.default.createElement("div", { className: c("items"), "data-testid": "add-block-menu" }, blockTypes.map(function (blockType) {
                        var config = _this.getItemConfiguration(blockType);
                        return (react_1.default.createElement(AddBlockMenuItem_1.AddBlockMenuItem, __assign({ key: blockType, onClick: function () { return _this.onSelectBlockType(blockType); } }, config)));
                    })),
                    !hideAddFromLibrary && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("hr", { className: c("hr") }),
                        react_1.default.createElement("div", { className: "space-inset-xs" },
                            react_1.default.createElement(kaleidoscope_1.Button, { className: "add-from-library", type: kaleidoscope_1.ButtonType.Tertiary, onClick: onAddFromLibraryClick }, "Add block from library")))))); })),
                this.currentPanel === "presets" && this.selectedConfig && (react_1.default.createElement(react_transition_group_1.Transition, { timeout: kaleidoscope_3.AnimationDuration.Long, onEnter: this.setPanelHeight }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("popover-panel"), c("popover-panel", "presets"), c("popover-panel", status)) },
                    react_1.default.createElement("div", { className: c("action") },
                        react_1.default.createElement("div", { className: c("action-button") },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ChevronLeft, null), type: kaleidoscope_1.ButtonType.Tertiary, onClick: _this.onClosePresets, "aria-label": "Back" })),
                        react_1.default.createElement("div", { className: c("action-label") }, _this.selectedConfig.presetTitle)),
                    react_1.default.createElement("div", { className: c("presets") }, _this.selectedConfig.presets.map(function (preset, index) { return (react_1.default.createElement("div", { className: c("preset-tile"), key: preset.title },
                        react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: c("preset-tile-card"), onClick: function () { return _this.onSelectPreset(_this.selectedConfig.blockType, preset.preset); }, "aria-labelledby": "".concat(_this.selectedConfig.blockType, "-").concat(preset.preset), "data-testid": "preset-".concat(_this.selectedConfig.blockType, "-").concat(index) },
                            react_1.default.createElement("div", { className: c("preset-tile-thumb"), style: { backgroundImage: "url(".concat(preset.image, ")") } }),
                            react_1.default.createElement("div", { className: c("preset-tile-overlay") },
                                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, as: "div" }, "Choose preset"))),
                        react_1.default.createElement("div", { id: "".concat(_this.selectedConfig.blockType, "-").concat(preset.preset), className: c("preset-tile-label") }, preset.title),
                        !!preset.description && (react_1.default.createElement("div", { className: c("preset-tile-description") }, preset.description)))); })))); })))));
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_a = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _a : Object)
    ], AddBlockMenu.prototype, "usingFeature", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("project"),
        __metadata("design:type", typeof (_b = typeof ProjectTypes_1.IProject !== "undefined" && ProjectTypes_1.IProject) === "function" ? _b : Object)
    ], AddBlockMenu.prototype, "project", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AddBlockMenu.prototype, "currentPanel", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "selectedConfig", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "panelHeight", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AddBlockMenu.prototype, "popoverRef", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "onSelectBlockType", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "onSelectPreset", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "onClosePresets", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddBlockMenu.prototype, "setPanelHeight", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AddBlockMenu.prototype, "componentDidMount", null);
    AddBlockMenu = __decorate([
        mobx_react_1.observer
    ], AddBlockMenu);
    return AddBlockMenu;
}(react_1.default.Component));
exports.AddBlockMenu = AddBlockMenu;
